// Routes die de gedeelde laag "Verfijnd LoanLink" (style/ll-refined.scss)
// gebruiken voor kop, mobiele schil, dossiermenu en onderdeelkeuze.
export const REFINED_LAYOUT_ROUTES = ["Financieringsopzet"] as const;

export function isRefinedLayoutRoute(name: unknown): boolean {
	if (typeof name !== "string") return false;
	return (REFINED_LAYOUT_ROUTES as readonly string[]).includes(name);
}
